module.exports = __webpack_public_path__ + "static/basics-desktop-update-10a84c75251ffe36c73b459568cdd8c4.png";